import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { IconProps } from '../iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconGear({
  extColor,
  isAutoscallable = true,
  sizeKey = '16x16',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.text.secondary;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 17"
      fill={fill}
    >
      <g clipPath="url(#clip0_3779_5589)">
        <path d="M6.13403 0.565552C5.98715 0.637426 5.8559 0.778051 5.79653 0.921802C5.77465 0.971802 5.69653 1.44993 5.62153 1.98118L5.48403 2.94368L5.23403 3.06868C5.09653 3.13743 4.86528 3.2718 4.72153 3.36555L4.4559 3.53743L3.54653 3.17493C2.74965 2.85618 2.61215 2.81243 2.45278 2.81243C2.2434 2.81243 2.0559 2.88743 1.9309 3.0218C1.86215 3.0968 0.499653 5.42493 0.277778 5.8468C0.180903 6.03118 0.177778 6.3343 0.271528 6.51555C0.355903 6.67805 0.384028 6.70305 1.2184 7.34993L1.92153 7.8968L1.9184 8.50305L1.91528 9.10618L1.26215 9.61868C0.368403 10.3156 0.352778 10.3312 0.274653 10.4781C0.184028 10.6562 0.184028 10.9656 0.271528 11.1406C0.418403 11.4249 1.82153 13.8374 1.90278 13.9374C2.02778 14.0968 2.22465 14.1874 2.44965 14.1874C2.61215 14.1874 2.7434 14.1437 3.54653 13.8249L4.45903 13.4624L4.65903 13.5968C4.7684 13.6718 4.99965 13.8062 5.17153 13.8968L5.48403 14.0562L5.62778 15.0593C5.78715 16.1749 5.80278 16.2218 6.0684 16.3968L6.19965 16.4843L7.93403 16.4937C9.0559 16.4999 9.70903 16.4906 9.7809 16.4718C9.93403 16.4249 10.109 16.2749 10.184 16.1187C10.2278 16.0249 10.284 15.7156 10.3747 15.0781C10.4434 14.5781 10.5059 14.1437 10.5153 14.1093C10.5247 14.0656 10.6028 14.0093 10.7559 13.9374C10.8809 13.8781 11.109 13.7468 11.2622 13.6437L11.5434 13.4624L12.459 13.8281C13.2215 14.1312 13.4028 14.1906 13.5403 14.1906C13.759 14.1906 13.9465 14.1124 14.0715 13.9687C14.1528 13.8749 15.5153 11.5468 15.7372 11.1249C15.8184 10.9687 15.8122 10.6499 15.7247 10.4781C15.6465 10.3281 15.5903 10.2781 14.7215 9.60305L14.0872 9.10618V8.49993V7.89368L14.7372 7.3843C15.6278 6.68743 15.6465 6.6718 15.7247 6.5218C15.8215 6.33743 15.8184 6.0343 15.7184 5.84368C15.5278 5.4718 14.1403 3.0968 14.0653 3.01868C13.9434 2.88743 13.7622 2.81243 13.5497 2.81243C13.384 2.81243 13.259 2.85305 12.4622 3.1718C11.7028 3.47493 11.5497 3.52493 11.4934 3.4968C11.459 3.47805 11.3278 3.3968 11.2059 3.31555C11.0809 3.23743 10.8778 3.1218 10.7559 3.06243C10.6028 2.99055 10.5247 2.9343 10.5153 2.89055C10.509 2.85618 10.4434 2.41868 10.3715 1.9218C10.3028 1.4218 10.2247 0.971802 10.2028 0.921802C10.1434 0.774926 10.009 0.634301 9.86528 0.565552C9.73403 0.503052 9.68715 0.499927 7.99653 0.499927C6.29965 0.499927 6.26215 0.499927 6.13403 0.565552ZM8.64028 5.93743C9.58715 6.18118 10.3059 6.8968 10.5653 7.8593C10.6184 8.05305 10.634 8.1968 10.634 8.49993C10.634 8.80305 10.6184 8.9468 10.5653 9.14055C10.3059 10.0999 9.59965 10.8062 8.64028 11.0656C8.28715 11.1624 7.71215 11.1624 7.35903 11.0656C6.39965 10.8062 5.69028 10.0999 5.43403 9.14055C5.34028 8.79055 5.34028 8.2093 5.43403 7.8593C5.81528 6.43118 7.24028 5.57805 8.64028 5.93743Z" />
      </g>
      <defs>
        <clipPath id="clip0_3779_5589">
          <rect width="16" height="16" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
